import axios from "axios";
//import { BASE_URL } from "../environment";

export const getPaymentsReport = async (startDate, endDate) => {
  try {
    const url = `/payment/getAll`;
    const params = {};
    
    if (startDate && endDate) {
      params.startDate = startDate.format('YYYY-MM-DD');
      params.endDate = endDate.format('YYYY-MM-DD');
    }
    
    const response = await axios.get(url, { params });
    
    // Validate the response
    if (response.data && response.data.data) {
      // Make sure we're returning an array
      const data = Array.isArray(response.data.data) ? response.data.data : [];
      
      // Pre-process to filter out records with null 'invoice' property
      return data.filter(record => record && record.invoice);
    } else {
      console.error("Unexpected API response format:", response);
      return [];
    }
  } catch (error) {
    console.error("Error fetching payment reports:", error);
    throw error;
  }
};
